export const name: string = 'Grid';
export const group = 'Charting';
export const moduleName: string = 'pdc-widget-grid';
export const icon: string = 'list-alt';
export const namespace: string = 'business-intelligence';
export const themeId: string = 'widget-grid'; //VR: Theme ID (to SELECT and EXPAND it in Theme dialog)
//export const priority: number = 1;

export const sections = {
    rows: 'widget-grid-rows-section',
    groupRows: 'widget-grid-group-rows-section',
    toolbar: 'widget-grid-toolbar-section'
};

export const themeFields = {
    themeGroup_Options: 'grid-group-options',
    themeGroup_FilterRow: 'grid-group-filter-row',
    themeGroup_WordWrap: 'grid-group-word-wrap',
    themeGroup_Groupings: 'grid-group-groupings',
    themeGroup_ColumnOptions: 'grid-group-column-options',

    rowHighligtingColor: 'widget-grid-row-highlighting-color',
    showCollapseExpandButton: 'widget-grid-show-collapse-expand-button',
    showCollapseGroupingsByDefault: 'widget-grid-show-collapse-groupings-by-default',
    allowGroupCollapsing: 'widget-grid-allow-group-collapsing',
    allowGrouping: 'widget-grid-allow-grouping',
    allowFilterRow: 'widget-grid-allow-filter-row',
    filterRowEnabled: 'widget-grid-filter-row-enabled',
    allowWordWrap: 'widget-grid-allow-word-wrap',
    wordWrapEnabled: 'widget-grid-word-wrap-enabled',
    showToolbar: 'widget-grid-show-grid-toolbar',
    showGroupPanel: 'widget-grid-show-group-panel',
    useRowMode: 'widget-grid-use-row-mode',
    rowSelectionMode: 'widget-grid-row-selection-mode',
    selectFirstRowOnUpdate: 'widget-grid-select-first-row-on-update',
    hideNoDataMessage: 'widget-grid-hide-no-data-message',
    rowbgColor: 'widget-grid-rowbg-color',
    rowColor: 'widget-grid-row-color',
    rowAlternation: 'widget-grid-row-alternation',
    showColumnHeaders: 'widget-grid-show-column-headers'
};
